import React, { Component } from 'react';
import styleable from 'react-styleable';
import { injectIntl, intlShape } from 'react-intl';
import clone from 'lodash/clone';
import cloneDeep from 'lodash/cloneDeep';
import PropTypes from 'prop-types';
import css from './index.scss';
import DropDownList from '../../components/dropdown-list/index';
import SearchBox from '../search-box/index';
import { SolidLeft, SolidRight, StudentManagement } from '../../helpers/icon-dictionary';
import Button from '../../components/button/index';
import AssignItem from '../assign-item/index';
import EmptyState from '../../components/empty-state/index';
import messages from '../assign-user/messages';
import assignMessages from './messages';

class Assign extends Component {
    constructor(props) {
        super(props);
        this.state = {
            enableForwardButton: false,
            enableBackButton: false,
            assignedListItemIds: [],
            unAssignedListItemIds: []
        };

        this.assignItem = this.assignItem.bind(this);
        this.unAssignItem = this.unAssignItem.bind(this);
        this.handleOnYearGroupSelection = this.handleOnYearGroupSelection.bind(this);
    }

    assignItem = () => {
        this.props.handleOnAssignItem(this.state.assignedListItemIds);
        this.setState({ assignedListItemIds: [], enableForwardButton: false });
    };

    unAssignItem = () => {
        this.props.handleOnUnAssignItem(this.state.unAssignedListItemIds);
        this.setState({ unAssignedListItemIds: [], enableBackButton: false });
    };

    updateItems = (clonedObject, itemId, checked) => {
        if (checked) {
            return clonedObject.concat(parseInt(itemId, 10));
        }
        const filteredArray = clonedObject.filter(val => val !== parseInt(itemId, 10));
        return filteredArray;
    }

    handleOnItemSelection = (element, checked) => {
        const { isSaveInProgress, type } = this.props;
        const itemId = element.split('-')[1];
        const category = element.split('-')[2];
        const updateFwdButtonState = () => {
            if (isSaveInProgress) {
                this.setState({ enableBackButton: false });
            } else {
                this.setState({ enableForwardButton: this.state.assignedListItemIds.length });
            }
        };
        const updateBackButtonState = () => {
            if (isSaveInProgress) {
                this.setState({ enableBackButton: false });
            } else {
                this.setState({ enableBackButton: this.state.unAssignedListItemIds.length });
            }
        };

        if (category === 'assign') {
            this.setState({ assignedListItemIds: this.updateItems(clone(this.state.assignedListItemIds), itemId, checked) }, updateFwdButtonState);
        } else {
            this.setState({ unAssignedListItemIds: this.updateItems(clone(this.state.unAssignedListItemIds), itemId, checked) }, updateBackButtonState);
        }

        if (type === 'student') {
            this.props.handleOnClassroomSelection(parseInt(itemId, 10));
        }
    }

    handleOnChildSelection = (itemId, groups) => {
        this.props.handleOnChildSelection(itemId, groups);
    };

    handleOnYearGroupSelection = (name, val) => {
        this.state.assignedListItemIds = [];
        this.props.handleOnYearGroupSelection(name, val);
    }

    getLists = () => {
        const { type, intl, leftList, rightList } = this.props;
        let index = 0;
        let leftPanelElements = [];
        let rightPanelElements = [];
        const emptyStateMessage = type === 'class' ?
            intl.formatMessage(messages.teacherEmptyState) :
            intl.formatMessage(messages.unassignedEmptyState);
        if (leftList.length > 0) {
            leftPanelElements = leftList.map((val) => {
                index += 1;
                return (<div className={css.assignItemContainer} key={`${val.listItemId}_${index}`}><AssignItem
                    child={val.child}
                    elementId={val.elementId}
                    handleOnChildSelection={this.handleOnChildSelection}
                    handleOnItemSelection={this.handleOnItemSelection}
                    id={val.listItemId}
                    info={val.info}
                    isExpandable={val.isExpandable}
                    name={val.name}
                />
                </div>);
            });
        } else {
            leftPanelElements = (
                <EmptyState
                    iconName={StudentManagement}
                    message={emptyStateMessage} />);
        }

        if (rightList.length > 0) {
            rightPanelElements = rightList.map((val) => {
                index += 1;
                return (<div className={css.assignItemContainer} key={`${val.listItemId}_${index}`}><AssignItem
                    child={val.child}
                    elementId={val.elementId}
                    handleOnChildSelection={this.handleOnChildSelection}
                    handleOnItemSelection={this.handleOnItemSelection}
                    id={val.listItemId}
                    info={val.info}
                    isExpandable={val.isExpandable}
                    name={val.name}
                />
                </div>);
            });
        } else {
            rightPanelElements = (
                <EmptyState
                    iconName={StudentManagement}
                    message={emptyStateMessage} />);
        }

        return {
            leftPanelElements,
            rightPanelElements
        };
    }
    render() {
        const data = this.getLists();
        const { intl, header, selectedYearGroup, type, yearGroups,
            isSaveInProgress } = this.props;
        const typeString = type === 'class' ? intl.formatMessage(messages.teachers) : intl.formatMessage(messages.classes);
        const clonedYearGroups = cloneDeep(yearGroups);

        if (clonedYearGroups) {
            delete clonedYearGroups[0];
        }

        const yearGroupDropdown = (<DropDownList
            name="yearGroup"
            onChange={this.handleOnYearGroupSelection}
            options={clonedYearGroups}
            placeholder={intl.formatMessage(assignMessages.allYears)}
            value={selectedYearGroup}
        />);
        const dropdownList = type !== 'class' ? yearGroupDropdown : <div />;
        return (
            <div className={css.assignContainer}>
                <div className={css.panel}>
                    <span className={css.panelHeader}>
                        {`${intl.formatMessage(messages.available)} ${typeString}`}</span>
                    <div className={css.panelBody}>
                        <div className={css.leftPanelHeader}>
                            {dropdownList}
                            <SearchBox handleOnSearchClick={this.props.handleOnSearchClick} />
                        </div>
                        <div className={css.leftPanel}> {data.leftPanelElements} </div>
                    </div>
                </div>
                <div className={css.moveButtons}>
                    <Button
                        containerClassName={css.assignButton}
                        disabled={!this.state.enableForwardButton || isSaveInProgress}
                        handleOnClick={this.assignItem}
                        icon={SolidRight}
                        iconClassName={css.iconClassName} />
                    <Button
                        buttonContainerDisabled={css.buttonContainerDisabled || isSaveInProgress}
                        containerClassName={css.assignButton}
                        disabled={!this.state.enableBackButton}
                        handleOnClick={this.unAssignItem}
                        icon={SolidLeft}
                        iconClassName={css.iconClassName} />
                </div>
                <div className={css.panel}>
                    <span
                        className={css.panelHeader}>
                        {`${typeString} ${intl.formatMessage(messages.assignedTo)}
                        ${header}`}
                    </span>
                    <div className={css.rightPanel} >
                        {data.rightPanelElements}
                    </div>
                </div>
            </div>
        );
    }
}

Assign.propTypes = {
    header: PropTypes.string,
    yearGroups: PropTypes.array,
    selectedYearGroup: PropTypes.string,
    leftList: PropTypes.array,
    rightList: PropTypes.array,
    isSaveInProgress: PropTypes.bool,
    intl: intlShape.isRequired,
    type: PropTypes.string,
    handleOnAssignItem: PropTypes.func,
    handleOnUnAssignItem: PropTypes.func,
    handleOnClassroomSelection: PropTypes.func,
    handleOnChildSelection: PropTypes.func,
    handleOnYearGroupSelection: PropTypes.func,
    handleOnSearchClick: PropTypes.func
};

export default injectIntl((styleable(css)(Assign)));



// WEBPACK FOOTER //
// ./app/components/assign/index.js